import {styled} from '../../../utils';
import {Main} from '../../Layout';
import {padding} from 'polished';

// FIXME: currently doing calculation on possible string
export default styled(Main)(({theme}) => padding(20 + Number(theme.globalHeader.height), 30, 20));



// WEBPACK FOOTER //
// ./src/components/GlobalLayout/Main/Main.tsx